module.exports = __webpack_public_path__ + "img/ml-heart-filled.a695f6b3.png";